var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47494 11.9632C5.35894 8.79221 7.83024 6.1252 11.0005 6C14.1708 6.1252 16.6421 8.79221 16.5261 11.9632C16.5261 13.2802 17.957 14.5632 17.999 15.8833C17.999 15.902 17.999 15.9206 17.999 15.9393C18.0299 16.785 17.3707 17.4962 16.5251 17.5293H13.3334C13.3363 18.1773 13.092 18.8022 12.6504 19.2764C12.2257 19.7376 11.6274 20 11.0005 20C10.3736 20 9.77536 19.7376 9.35068 19.2764C8.90898 18.8022 8.66474 18.1773 8.6677 17.5293H5.47494C4.62938 17.4962 3.97009 16.785 4.00105 15.9393C4.00105 15.9206 4.00105 15.902 4.00105 15.8833C4.04405 14.5672 5.47494 13.2812 5.47494 11.9632Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.5L14 17.5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H13",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.03fc6df731dfecb353493614125e9a21.svg";
export { ForwardRef as ReactComponent };